import { render, staticRenderFns } from "./SafetyObservationListing.vue?vue&type=template&id=73022d46"
import script from "./SafetyObservationListing.vue?vue&type=script&lang=js"
export * from "./SafetyObservationListing.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationListing.vue?vue&type=style&index=0&id=73022d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports